var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRussian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 21,
    viewBox: "0 0 33 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.400391,
    width: 32.4,
    height: 21,
    fill: "url(#pattern0_1175_963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1175_963",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1175_963",
    transform: "matrix(0.00125 0 0 0.00192857 0 -0.0139643)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1175_963",
    width: 800,
    height: 533,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyAAAAIVBAMAAADbnobxAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAD1BMVEX///+qveEAOaaOMEvVKx7/j+iDAAAAAWJLR0QAiAUdSAAAAAd0SU1FB+YEEw06NLcgtREAAAJcSURBVHja7dExAQAwDMOwUCiFURiF8cdUBPtzSBDsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+Buq5FDFEEMwxBAMMQRDDMEQQzAEQwzBEEMwxBAMMQRDMMQQDDEEQwzBEEMwBEMMwRBDMMQQDDEEQzDEEAwxBEMMwRBDMARDDMEQQzDEEAwxBEMwxBAMMQRDDMEQQzAEQwzBEEMwxBAMMQRDMMQQDDEEQwzBEEMwBEMMwRBDMMQQDDEEQwzBEAwxBEMMwRBDMMQQDMEQQzDEEAwxBEMMwRAMMQRDDMEQQzDEEAzBEEMwxBAMMQRDDMEQDDEEQwzBEEMwxBAMwRBDMMQQDDEEQwzBEAwxBEMMwRBDMMQQDMEQQzDEEAwxBEMMwRAMMQRDDMEQQzDEEAwxRIKyIZcqeVQxxBAMMQRDDMEQQzDEEAzBEEMwxBAMMQRDDMEQDDEEQwzBEEMwxBAMwRBDMMQQDDEEQwzBEAwxBEMMwRBDMMQQDMEQQzDEEAwxBEMMwRAMMQRDDMEQQzDEEAzBEEMwxBAMMQRDDMEQDDEEQwzBEEMwxBAMwRBDMMQQDDEEQwzBEEMwBEMMwRBDMMQQDDEEQzDEEAwxBEMMwRBDMARDDMEQQzDEEAwxBEMwxBAMMQRDDMEQQzAEQwzBEEMwxBAMMQRDMMQQDDEEQwzBEEMwBEMMwRBDMMQQDDEEQzDEEAwxBEMMwRBDMARDDMEQQzDEEAwxBEMMkaDLAsQVohM2mir3AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTA0LTE5VDEzOjU4OjUyKzAwOjAwDEMZTgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0wNC0xOVQxMzo1ODo1MiswMDowMH0eofIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussian);
export default __webpack_public_path__ + "static/media/Russian.8552919531c445b9cc494c05b9de0979.svg";
export { ForwardRef as ReactComponent };